// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__3tfqY","shimmer":"styles_shimmer__157lE"};